import {useViewerQuery} from './__generated__/useViewer.graphql';

type Viewer = {
  id?: string;
  profile?: {
    firstName: string;
    imageUrl?: string;
    lastName: string;
  };
};

/**
 * useViewer is a custom React hook that fetches and returns the current viewer's data and loading state.
 *
 * @function
 * @returns {{loading: boolean, viewer: Viewer}} An object containing the loading state and viewer data.
 */
const useViewer = (): {loading: boolean; viewer: Viewer} => {
  const {data, loading} = useViewerQuery({
    nextFetchPolicy: 'cache-and-network',
  });

  const viewer = data?.viewer;

  if (loading || !viewer) return {loading, viewer: {}};

  const {id, profile} = viewer;

  if (!profile) return {loading, viewer: {id}};

  const {firstName, lastName, photoDownloadUrl} = profile;

  const outProfile: Viewer['profile'] = {
    firstName,
    lastName,
    imageUrl: photoDownloadUrl || undefined,
  };

  return {loading, viewer: {id, profile: outProfile}};
};

export default useViewer;
